import { NavLink, Outlet, useLocation } from "react-router-dom";
import "./Layout.scss";

export default function Layout() {

    const location = useLocation();

    const handleActive = (isActive) => {
        return `navigation-child ${isActive && 'bg-primary text-secondary'} d-block d-sm-flex ms-4 me-4 me-sm-0`
    }
       
    return (
        <div className="layout-section">
            <div className="navigation">
                <div className="navigation-section fw-light d-block d-sm-flex pt-3">
                    <NavLink to="/"  
                    className={
                        ({ isActive }) => handleActive(isActive)
                    }>
                        <div className="text mx-3">Home</div>
                        <div className={`button-folder-angle ${(location.pathname==="/") && 'bg-primary'}`}></div>
                    </NavLink>
                    <NavLink to="/technologies"  
                    className={
                        ({ isActive }) => handleActive(isActive)
                    }>
                        <div className="text mx-3">Technologies</div>
                        <div className={`button-folder-angle ${(location.pathname==="/technologies") && 'bg-primary'}`}></div>
                    </NavLink>
                    <NavLink to="/projects"  
                    className={
                        ({ isActive }) => handleActive(isActive, "")
                    }>
                        <div className="text mx-3">Projects</div>
                        <div className={`button-folder-angle ${(location.pathname==="/projects") && 'bg-primary'}`}></div>
                    </NavLink>
                    <NavLink to="/contact"  
                    className={
                        ({ isActive }) => handleActive(isActive)
                    }>
                        <div className="text mx-3">Contact</div>
                        <div className={`button-folder-angle ${(location.pathname==="/contact") && 'bg-primary'}`}></div>
                    </NavLink>
                </div>
              </div>
            <div className="content border-top border-primary py-3 px-3 py-sm-4 px-sm-5">
              <Outlet />
            </div>
        </div>
    )
}